import script from "./PersonItemCompact.vue?vue&type=script&setup=true&lang=ts"
export * from "./PersonItemCompact.vue?vue&type=script&setup=true&lang=ts"

import "./PersonItemCompact.vue?vue&type=style&index=0&id=216f589a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216f589a"]])

export default __exports__